import PickBirthdayContainer from '../components/pick-birthday/pick-birthday-redux'

export default PickBirthdayContainer
